import axios from 'axios'
import { MaintenanceNotice } from '@/models/MaintenanceNotice'

export const maintenanceApi = {
    async getNotice(language: string): Promise<MaintenanceNotice | null> {
        try {
            const client = axios.create({ baseURL: axios.defaults.baseURL })
            const response = await client.get('maintenance', { params: { lang: language } })
            return response.status === 200 ? response.data : null
        } catch {
            return null
        }
    }
}
